import { Controller } from '@hotwired/stimulus';

export default class CheckboxSelectAll extends Controller {
  declare public readonly hasCheckboxAllTarget: boolean;
  declare public readonly checkboxTargets: HTMLInputElement[];
  declare public readonly checkboxAllTarget: HTMLInputElement;

  public static targets: string[] = ['checkboxAll', 'checkbox'];

  public checkboxAllTargetConnected(checkbox: HTMLInputElement): void {
    checkbox.addEventListener('change', this.toggle.bind(this));

    this.refresh();
  }

  public checkboxTargetConnected(checkbox: HTMLInputElement): void {
    checkbox.addEventListener('change', this.refresh.bind(this));

    this.refresh();
  }

  public checkboxAllTargetDisconnected(checkbox: HTMLInputElement): void {
    checkbox.removeEventListener('change', this.toggle.bind(this));

    this.refresh();
  }

  public checkboxTargetDisconnected(checkbox: HTMLInputElement): void {
    checkbox.removeEventListener('change', this.refresh.bind(this));

    this.refresh();
  }

  public toggle(e: Event): void {
    e.preventDefault();

    this.checkboxTargets.forEach(checkbox => {
      checkbox.checked = (e.target as HTMLInputElement).checked;
      this.triggerInputEvent(checkbox);
    });
  }

  public refresh(): void {
    const checkboxesCount = this.checkboxTargets.length;
    const checkboxesCheckedCount = this.checked.length;

    this.checkboxAllTarget.checked = checkboxesCheckedCount > 0;
    this.checkboxAllTarget.indeterminate =
      checkboxesCheckedCount > 0 && checkboxesCheckedCount < checkboxesCount;
  }

  public triggerInputEvent(checkbox: HTMLInputElement): void {
    const event = new Event('input', { bubbles: false, cancelable: true });

    checkbox.dispatchEvent(event);
  }

  public get checked(): HTMLInputElement[] {
    return this.checkboxTargets.filter(checkbox => checkbox.checked);
  }

  public get unchecked(): HTMLInputElement[] {
    return this.checkboxTargets.filter(checkbox => !checkbox.checked);
  }
}
